import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const SUPPORTED = ['sv', 'en'] as const
type SupportedLng = (typeof SUPPORTED)[number]

function isSupported(value: string): value is SupportedLng {
  return (SUPPORTED as readonly string[]).includes(value)
}

export interface LanguageSwitcherProps {
  className?: string
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation('common')
  const current: SupportedLng = isSupported(i18n.language) ? i18n.language : 'sv'

  useEffect(() => {
    document.documentElement.lang = current
  }, [current])

  return (
    <div
      className={className}
      role="group"
      aria-label={t('language.label')}
      style={{
        display: 'inline-flex',
        gap: 4,
        padding: '4px 12px',
        alignItems: 'center',
        fontSize: 13,
      }}
    >
      {SUPPORTED.map((lng) => {
        const active = lng === current
        return (
          <button
            key={lng}
            type="button"
            onClick={() => {
              if (!active) void i18n.changeLanguage(lng)
            }}
            aria-pressed={active}
            style={{
              background: 'transparent',
              border: 'none',
              padding: '4px 6px',
              cursor: active ? 'default' : 'pointer',
              fontWeight: active ? 700 : 500,
              color: 'inherit',
              opacity: active ? 1 : 0.7,
            }}
          >
            {t(`language.${lng}`)}
          </button>
        )
      })}
    </div>
  )
}
